// removed by extract-text-webpack-plugin
module.exports = {"container":"container--3a_KI","item":"item--3qwhJ","item-label":"item-label---qAfa","img-wrapper":"img-wrapper--wBFgu"};


//////////////////
// WEBPACK FOOTER
// ./client/components/product-selector/product-selector.scss
// module id = 497
// module chunks = 0